

export const Mainlaystyle = (theme) => ({
    rootBox: {
        display: "grid",
        gridTemplateColumns: "1.1fr 5fr",
        height: "100vh",
        width: '100vw',
        overflowX: "hidden",
    },
    componentDiv: {
        flexGrow: 1, display: "flex", flexDirection: "column"
    },

    outletDiv: {
        height: "90vh",
        overflowY: "auto",
        p: 2,
        width: '100%',
        overflowX: "auto",
        background: theme.palette.primary.backgroundMain,
    },

    HeaderDiv: {
        height: "10vh",
        borderBottom: `1px solid ${theme.palette.border.thin}`,
        display: "flex",
        alignItems: "center",
        px: '0.5rem',
    }
})



export const sidenavStyle = (theme) => ({
    active: {
        borderRight: `3px solid ${theme.palette.primary.main}`,
        backgroundColor: "#ffa2001a",
        color: theme.palette.primary.main,
    },

    inactive: {
        fontWeight: "bold",
        mb: 0.5,
        color: theme.palette.text.primary,
        bgcolor: "transparent",
        "&:hover": {
            bgcolor: "rgba(224,221,220,0.3)",
        },
    },

    drawerDiv: {
        flex: 1,
        "& .MuiDrawer-paper": {
            position: "relative",
            width: "100%",
            boxSizing: "border-box",
            borderRight: `1px solid ${theme.palette.border.thin}`,
        },
    },

    logo: {
        width: "45px",
        height: "45px",
        objectFit: "contain",
    },

    sidenavHeader: {
        p: 2,
        borderBottom: `1px solid ${theme.palette.border.thin}`,
        display: "flex",
        alignItems: "center",
        gap: 1,
        height: '10vh'
    },

    sidenavBody: {
        height: "90vh",
        overflowY: "hidden",
        "&:hover": {
            overflowY: "auto"
        }
    },

    versionDiv: {
        m: 1,
        mx: 2,
        p: 1,
        border: `1px solid ${theme.palette.border.thin}`,
        borderRadius: 1,
        "&:hover": {
            bgcolor: "rgba(224,221,220,0.2)",
            borderColor: `${theme.palette.border.thin}`,
        },
    },
})

export const HeaderStyles = (theme) => ({
    appBar: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: "none",
        p: 0,
    },
    title: {
        fontSize: "1rem",
        fontWeight: 600,
        color: theme.palette.text.primary,

    },
    subtitle: {
        color: theme.palette.text.secondary,
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 0,
    },
    iconButton: {
        position: "relative",
        width: 40,
        height: 40,
    },
    bellIcon: {
        width: 20,
        height: 20,
        color: theme.palette.text.primary,
    },
    badge: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        fontSize: "0.75rem",
        width: 20,
        height: 20,
        minWidth: 20,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    version: {
        mb: 2,
        p: 1,
        borderBottom: `1px solid ${theme.palette.border.thin}`,
        borderRadius: 1,
        bgcolor: "#fffdf8",
    },

    mainHeading: {
        fontSize: 20,
        fontWeight: 600,
        color: theme.palette.text.primary
    },

    flex_c: {
        display: "flex",
        alignItems: "center",
        gap: 1,
    },

    userIcon: {
        width: 30,
        height: 30,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: theme.palette.primary.main,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
})

export const logoutStyles = (theme) => ({
    rootDiv: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        my: 2,
    },

    title: {
        fontWeight: "bold",
        fontSize: "1.4rem",
        textAlign: "center",
        pb: 1,
    },

    subtitle: {
        textAlign: "center",
        fontSize: "1rem",
        color: "text.secondary",
    },

    btnDiv: {
        justifyContent: "center",
        gap: 2,
        pb: 2
    }
})